import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order_id?: number | string;
};

const OrderIdCell = React.memo((row: KpiWorkunitGridData) => (
  <span>
    {row?.order_id && (
      <Tooltip title={row?.order_id}>
        <Typography variant="body2" noWrap>
          {row?.order_id}
        </Typography>
      </Tooltip>
    )}
  </span>
));

export default OrderIdCell;
